import { ProjectService } from '@alpha-core/platform-ui';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-main-sidenav',
    standalone: true,
    templateUrl: './main-sidenav.component.html',
    imports: [...PrimeNGModules, TranslatePipe],
})
export class MainSidenavComponent {
    projectService = inject(ProjectService);

    @Output() pageEmitter = new EventEmitter<any>();
    @Input() categorizedPages: any;

    pageId: string = '';

    @Input() activePageMenu: Record<string, number> = {
        activeMenuCategory: 0,
        activeCategoryItem: 0,
    };

    async setPage(page: any, parentIndex: number, pageIndex: number) {
        this.activePageMenu = {
            activeMenuCategory: parentIndex,
            activeCategoryItem: pageIndex,
        };
        this.pageEmitter.emit(page);
    }
}
